import { Component, OnInit, ViewEncapsulation, PLATFORM_ID, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { isPlatformServer } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { Cookie } from '../shared/cookie.service';
import { HeaderService } from '../shared/header.service';
import { CurrencyService } from '../shared/currency.service';
import { AnalyticsUtilsService } from '../shared/analytics-utils.service';
import { HttpCssClient } from '../shared/http-request.interceptor';
import { DeviceService } from '../shared/device.service';
import { AppSettings } from '../settings/app.settings';
import { BasketService } from '../services/basket.service';
import { HrefLang, HrefLangDefinition } from '../shared/hreflang.service';
import { LoadingComponent } from '../shared/components/loading/loading.component';


@Component({
  styleUrls: ['./basket.component.scss'],
  selector: 'basket',
  templateUrl: './basket.component.html',
  encapsulation: ViewEncapsulation.Emulated
})
export class BasketComponent implements OnInit{
  @ViewChild('loadUnits') loadingComponentUnits:LoadingComponent;
  public isNode:boolean;
  public items:Object[];
  public total:number = 0; 
  public voucherApplied:boolean = false;
  public voucher:string;
  public couponError: boolean = false;
  public isAgent: boolean = false;
  public isSubmited: boolean = false;
  public coupon: string;
  public transactionError:boolean = false;
  public crossSelling: any[];
  public actualCurrency:number;
  public hasCrossSelling:boolean;
  public buttonRemoveDisabled: boolean = false;
  
  constructor(private basketService:BasketService, private translate:TranslateService, 
    private cookie:Cookie, private headerService:HeaderService, private router:Router, 
    public currencyService:CurrencyService, private route:ActivatedRoute, private title:Title,
    private hlang:HrefLang, private analyticsUtils:AnalyticsUtilsService, 
    @Inject(PLATFORM_ID) private platformId:Object, private deviceService: DeviceService) {
    this.isNode = isPlatformServer(this.platformId);
  }

  ngOnInit() {
    this.isAgent = this.headerService.isAgent;
    this.route.params.subscribe(params => {
      this.initFunction();
    });
    this.currencyService.currencyUpdated.subscribe(currency => {
      if ((this.actualCurrency !== currency) && this.actualCurrency) {
        this.initFunction();
      }
    });
    this.translate.get("META_TITLE_BASKET").subscribe(text => {
      this.title.setTitle(text);
    });
    let langs = [
      {lang:'es',text:'carrito'}/*,
      {lang:'en',text:'shopping-cart'},
      {lang:'fr',text:'panier-achats'},
      {lang:'it',text:'carrello'},
    {lang:'de',text:'warenkorb'}*/];
    langs.forEach(lang => {
      let hreflang_:HrefLangDefinition = {
          rel: "alternate",
          href: `${AppSettings.BASE_DOMAIN}/${lang.lang}/${lang.text}`,
          hreflang: `${lang.lang}`
      }
      this.hlang.addTags([hreflang_]);
    }); 
  }

  private initFunction(){
    this.getActualCurrency(this.currencyService.currencyStr);
    this.getBasketItems();
  }

  getBasketItems(){
    this.total = 0;
    return this.basketService.getCurrentBasket().subscribe((basket: any)=>{
      if(basket != null){
        this.crossSelling = basket.crossSellingProducts;
        if(this.crossSelling && this.crossSelling.length){
          this.hasCrossSelling = true;
          this.crossSelling.map(el => {            
            let lang = el.textLanguage.locale;
            if (lang == null ||lang == '')
            {
              lang = 'en'
            }
            lang = lang.substring(0,2);
            el.url = `/${lang}/${el.location.id}/${el.location.urlName}/${el.id}/${el.urlName}`;
          })
        }else {
          this.hasCrossSelling = false;
        }
        let items = basket.sales;
        
        this.items = items.map((item)=>{
          this.total += item['amount'] * 100; //ADDED * 100
          item['unitsStr'] = item['units'].map(unit => {
            return unit['pax']>0?[unit["pax"],unit['personType']['name']]:null;
          });

          return item;
        });
        this.total = this.total/100;
        if(this.cookie.get()['voucher'] != null && this.cookie.get()['voucher'] != ''){
          this.voucher = this.cookie.get()['voucher'];
          if(!this.isNode)
            this.applyCoupon(this.voucher);
        }
      } else {
        this.headerService.numElementsCart = 0;
        this.cookie.put("guest_cart_element", "0");
      }
    },()=>{
      this.headerService.numElementsCart = 0;
      this.cookie.put("guest_cart_element","0");
   });
  }

  removeFromBasket(item:Object, event: Event){
    this.buttonRemoveDisabled = true;
    this.basketService.deleteFromBasket({id: item['id']}).subscribe(message => {
      if(message.response.updated == true){
          this.cookie.put("guest_session",message.token);
          this.cookie.put("guest_cart_element",message.response.numberOfSales);
          this.headerService.numElementsCart = parseInt(message.response.numberOfSales);
          
          var index = this.items.indexOf(item);
          this.items.splice(index,1);
          
          this.total = this.calculeTotal(this.items);
          this.analyticsUtils.eCommerce_removeFromCart(item, this.currencyService.currencyStr);

          if (this.voucherApplied == true) {
            if (this.items != null) {
              this.applyCoupon(this.coupon);
            }
          }

        }else if(message.token == null){
          this.cookie.remove("guest_session");
          this.cookie.put("guest_cart_element","0");
        } else if(message.response.errorMessage.includes("No transaction found for the user")){
          this.cookie.remove("guest_session");
          this.cookie.put("guest_cart_element","0");
          this.headerService.numElementsCart = 0;
          this.items = [];
          this.total = 0;
          this.transactionError = true;
        }
        this.buttonRemoveDisabled = false;
    });
    event.stopPropagation();
  }

  private getActualCurrency(currency){
    if(currency === "EUR"){
      this.actualCurrency = 1;
    } else if(currency === "GBP"){
      this.actualCurrency = 2;
    } else {
      this.actualCurrency = 3;
    }
  }

  getUrl(url:string){
    return `${this.deviceService.constructCloudfrontURL(AppSettings.CSS_CE_IMAGES,'SMALL')}/${url}`;
  }

  private calculeTotal(items:Object[]):number{
    
    let total = 0
    items.map(item => {
      if(!item['voucherApplied']){
        total += item['amount'] * 100; //ADDED *100
      }else{
        total += item['amountDiscount'] * 100; //ADDED *100
      }
    });
    total = total / 100;// Math.ceil((total / 100)*100)/100;
    return total;
  }

  private applyCoupon(code:string){
    this.analyticsUtils.apply_coupon(code);
    this.couponError = false;
    this.isSubmited = true;
    this.coupon = code;
    this.loadingComponentUnits.setHidden(false);
    let _itemsId = this.items.map(item => {
      return {id:item['id']};
    });
    this.basketService.useCoupon(code, _itemsId).subscribe(message => {
      this.loadingComponentUnits.setHidden(true);
      if(message['errorMessage'] == null){
        this.cookie.put('voucher',code);
        this.voucherApplied = true;
        this.items = this.items.map(item => {
          let saleFromServer = message['listSaleDTO'].find(function(e){
            return e['id'] == item['id'];
          });
          if(saleFromServer != null){
            item['voucherApplied'] = true;
            item['amountDiscount'] = saleFromServer['amount'];
          }
          return item;
        });
        this.total = this.calculeTotal(this.items);
        this.isSubmited = false;
      }else{
        this.couponError = true;
        this.isSubmited = false;
        this.removeCoupon();
      }
    });
  }

  private removeCoupon(){
    this.items = this.items.map(item => {
      this.cookie.remove('voucher');
      this.voucherApplied = false;
      this.isSubmited = false;
      delete item['voucherApplied'];
      delete item['amountDiscount'];
      return item;
    });
    this.total = this.calculeTotal(this.items);
  }

  private paymentGateway(){
    if(this.items != null){
      this.analyticsUtils.eCommerce_checkout(this.items, this.currencyService.currencyStr);
      this.translate.get("PAYMENT_URL").subscribe(url => {
        this.router.navigate([`/${this.translate.currentLang}/${url}`])
      })
    }
  }

  private navToProduct(product){    
    this.analyticsUtils.click_on_cross_sell();
    this.router.navigate([`${product.url}`]);
  }
}
